<template>
  <div class="hot-recommend box">
    <com-title title="热门推荐"></com-title>
    <div class="container hot-recommend-content">
      <ul class="tags-wrapper">
        <li v-for="(tag, index) of tags" :key="index">
          <router-link :to="{path: '/search', query: {id: tag.tag_id}}">
            <span>{{tag.name}}</span>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import comTitle from '@/components/com-h1'
export default {
  data () {
    return {}
  },
  components: {
    comTitle
  },
  props: ['tags']
}
</script>
<style scoped lang='sass'>
@import '../../style/variable.sass'

.hot-recommend
  background: url('https://static.geekbang.org/infoq/5aa5f19bcbd6e.png?imageView2/0/w/800')
  background-size: contain
  .hot-recommend-content
    display: flex
    justify-content: center
    align-items: center
    ul
      display: flex
      flex-wrap: wrap
      li
        margin: 0 20px
        display: inline-block
        +mobile
          margin: 0 15px 10px 0
        a
          display: block
          padding: 4px 35px
          border: 1px solid #3e3a39
          color: #3e3a39
          transition: all 0.3s linear
          +mobile
            font-size: 14px
            padding: 6px 30px
            display: flex
            align-items: center
          &:hover
            color: #246bb0
            border-color: #246bb0
</style>
